// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import UploadOutlined from '/Users/wyh/Documents/projects/brain/node_modules/@ant-design/icons/es/icons/UploadOutlined';
import AreaChartOutlined from '/Users/wyh/Documents/projects/brain/node_modules/@ant-design/icons/es/icons/AreaChartOutlined';
import SearchOutlined from '/Users/wyh/Documents/projects/brain/node_modules/@ant-design/icons/es/icons/SearchOutlined';
import CrownOutlined from '/Users/wyh/Documents/projects/brain/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import TeamOutlined from '/Users/wyh/Documents/projects/brain/node_modules/@ant-design/icons/es/icons/TeamOutlined';
export default { UploadOutlined, AreaChartOutlined, SearchOutlined, CrownOutlined, TeamOutlined };
